/*
 * ITEMS セクション：左右スクロールのスライダー（矢印操作 + スワイプ）
 */
(function () {
  function initSlider(slider) {
    var track = slider.querySelector('.items__track');
    if (!track) return;

    var prev = slider.querySelector('.items__nav--prev');
    var next = slider.querySelector('.items__nav--next');

    function step() {
      var card = track.querySelector('.items-card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollBy(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollBy(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollBy(1);
      });
    }

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    // カラーチップ：カードへの遷移を止めて、そのカラーの商品ページへ
    track.addEventListener('click', function (event) {
      var swatch = event.target.closest('.items-card__swatch');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      var href = swatch.getAttribute('data-href');
      if (href) window.location.href = href;
    });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var swatch = event.target.closest('.items-card__swatch');
      if (!swatch) return;
      event.preventDefault();
      var href = swatch.getAttribute('data-href');
      if (href) window.location.href = href;
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.items__slider:not([data-slider-init])').forEach(function (slider) {
      slider.setAttribute('data-slider-init', '');
      initSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
